import React, {useState, Fragment, useEffect} from 'react';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';
import { Card, CardContent } from '@mui/material';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import { Cancel, Save } from '@mui/icons-material';
import Formulario from 'components/formulario';
import { useSelector, useDispatch } from 'react-redux';
import { nombreDeAcciones } from 'constantes';
import { nuevoOActualizarRegistroPersonalizado, obtenerDepartamentosPersonalizado, obtenerMunicipiosPersonalizado, obtenerRegistrosPersonalizado } from 'store/actions/customAction';
import ServiciosDelAPI from 'servicios/ServiciosDelAPI';
import ModalDeConfirmacion from 'components/Modales/ModalDeConfirmacion';
import { functions } from 'constantes/functions';

const NuevaVallaFija= ({title, openFullScreenDialog, handleClose, datosDeEmpresa, datosGeneralesDelTarifario, datosEditados}) => {
  const {datosGenerales} = useSelector((state) => state);
  const dispatch = useDispatch();
  const [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeAlerta: 'error', mensajeDeAlerta: '', mostrarRespuesta: false, });
  const [mostrarAlertaDeErrorOExito, setMostrarAlertaDeErrorOExito] = useState(false);
  const[cargandoSolicitud, setcargandoSolicitud] = useState(false);
  const [tarifarioDeVallasFijas] = useState('tarifarioDeVallasFijas');
  const [catalogoTipoDeVallaFija] = useState('catalogoTipoDeVallaFija');
  const [catalogoSentidoVisualizacion] = useState('catalogoSentidoVisualizacion');
  const [catalogoDepartamentos] = useState('catalogoDepartamentos');
  const [catalogoMunicipios] = useState('catalogoMunicipios');
  const [departamentoYMunicipio, setDepartamentoYMunicipio] = useState({departamento: {}, municipio: {}});
  const [respuestDeExito, setRespuestaDeExito] = useState("");

  useEffect(() => {
    obtenerDepartamentos();
    obtenerTipoDeVallaFija();
    obtenerSentidoDeVisualizacion();
  },[])

  const obtenerSentidoDeVisualizacion = async () => {
    const copiaDeCampos = Object.assign({}, camposDelFormulario);

    if(datosGenerales.tipoSentidoDeVisualizacion.length > 0) {
        copiaDeCampos.sentidoDeVisualizacion.list = datosGenerales.tipoSentidoDeVisualizacion?.map( ({id, descripcion}) => ({id , name: descripcion}) );
        return setCamposDelFormulario(copiaDeCampos);
    }

    setcargandoSolicitud(true);
    let respuesta = await dispatch(obtenerRegistrosPersonalizado({
        controller: catalogoSentidoVisualizacion,
        validateIfDataExists: true,
        stateInStore: datosGenerales.tipoSentidoDeVisualizacion,
        dispatchAction: nombreDeAcciones.SETEAR_TIPO_DE_VISUALIZACION,
    }));

    setcargandoSolicitud(false);

    if(respuesta?.error || respuesta?.data?.length === 0) return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "", mostrarRespuesta: true, });

    copiaDeCampos.sentidoDeVisualizacion.list = respuesta?.data?.map( ({id, descripcion}) => ({id , name: descripcion}) )
    setCamposDelFormulario(copiaDeCampos);
  }

  const obtenerTipoDeVallaFija = async () => {
    const copiaDeCampos = Object.assign({}, camposDelFormulario);

    if(datosGenerales.tipoDeVallasFijas.length > 0) {
        copiaDeCampos.tipoDeValla.options = datosGenerales.tipoDeVallasFijas?.map( ({id, descripcion}) => ({value: id , label: descripcion}) );
        return setCamposDelFormulario(copiaDeCampos);
    }

    setcargandoSolicitud(true);
    let respuesta = await dispatch(obtenerRegistrosPersonalizado({
        controller: catalogoTipoDeVallaFija,
        validateIfDataExists: true,
        stateInStore: datosGenerales.tipoDeVallasFijas,
        dispatchAction: nombreDeAcciones.SETEAR_TIPO_DE_VALLAS_FIJAS,
    }));

    setcargandoSolicitud(false);

    if(respuesta?.error || respuesta?.data?.length === 0) return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "", mostrarRespuesta: true, });

    copiaDeCampos.tipoDeValla.options = respuesta?.data?.map( ({id, descripcion}) => ({value: id , label: descripcion}) )
    setCamposDelFormulario(copiaDeCampos);
  }

  const obtenerDepartamentos =async ()=> {
    setcargandoSolicitud(true);
    const copiaDeCampos = Object.assign({}, camposDelFormulario);

    if(datosGenerales.departamentos.length > 0) {
      if(datosGenerales.departamentos.length > 22 ) datosGenerales.departamentos.shift()
      copiaDeCampos.departamento.list = datosGenerales.departamentos?.map( ({id, nombre}) => ({id, name: nombre}) );
      setcargandoSolicitud(false);
      return setCamposDelFormulario(copiaDeCampos);
    }

    const dataCustomFetch = {
        controller: catalogoDepartamentos,
        validateIfDataExists: true,
        stateInStore : datosGenerales?.departamentos,
        dispatchAction:  nombreDeAcciones.OBTENER_DEPARTAMENTOS,
    }

    const respuesta = await dispatch(obtenerDepartamentosPersonalizado(dataCustomFetch));
    setcargandoSolicitud(false);

    if(respuesta?.error) setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "", mostrarRespuesta: true, });

    let datos = respuesta?.data?.map( ({id, nombre}) => ({id , name: nombre}) )
    copiaDeCampos.departamento.list = datos;
    setCamposDelFormulario(copiaDeCampos);
  };

  const obtenerMunicipios =async ({target}) => {
      const newState = Object.assign({}, camposDelFormulario);

      if(!target.value) {
          newState.municipio.list = [];
          newState.municipio.value = null;
          return;
      };

      setcargandoSolicitud(true);
      const dataCustomFetch = {
          controller: catalogoMunicipios,
          stateInStore : datosGenerales?.catalogos?.municipios,
          dispatchAction: nombreDeAcciones.OBTENER_MUNICIPIOS,
          departamentoID: target?.value
      }
      ServiciosDelAPI[catalogoMunicipios].metodoDeBusqueda.clear();
      ServiciosDelAPI[catalogoMunicipios].metodoDeBusqueda.setOperator("and");
      ServiciosDelAPI[catalogoMunicipios].metodoDeBusqueda.addEquals("departamento.id", target?.value);
      const respuesta = await dispatch(obtenerMunicipiosPersonalizado(dataCustomFetch));

      setcargandoSolicitud(false);
      if(respuesta?.error) {
          newState.municipio.list = [];
          newState.municipio.value = null;
          setDatosDeRespuesta({ errorType: 'error', messageType: respuesta.error?.message || "No se pudieron obtener los municipios", openResponse: true, });
      }

      let datos = respuesta?.data?.map( ({id, nombre}) => ({id , name: nombre}) )
      newState.municipio.list = datos;
      newState.municipio.value = null;
      setCamposDelFormulario(newState);
  };

  const {departamento, municipio, tipoDeVallaFija, costo, especDeContratacion, altoValla, anchoValla, coordenadas, sentidoDeVisualizacion, imagenDeValla, descripcionUbicacion, medioDeComunicacion} = datosGeneralesDelTarifario;

  const [camposDelFormulario, setCamposDelFormulario] = useState({
    tituloCobertura:{
          idelement: "tituloCobertura", title:'Departamento y Municipio', position:"center", elementType:'titulo', showTitleForm: true,  name: "tituloCobertura", value: "", isError:false,
      },
      departamento: {
          idelement: "departamento", value: departamento ? {id: departamento?.id, name: departamento?.nombre} : null, label: "Seleccione el departamento *", pattern:"^[0-9]{1,}$", validators: ['required'],
          errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [], handler: obtenerMunicipios, width: '40%', marginTop: '10px'
      },
      municipio: {
          idelement: "municipio", value: municipio ? {id: municipio?.id, name: municipio?.nombre} : null, label: "Seleccione el municipio *", pattern:"^[0-9]{1,}$", validators: ['required'],
          errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [], handler: undefined, width: '40%', marginTop: '10px'
      },
      titulodeValla:{
          idelement: "titulodeValla", title:'¿Qué tipo de valla es? *', position:"center", elementType:'titulo', showTitleForm: true, name: "titulodeValla", value: "", isError:false,
      },
      tipoDeValla:{
        idelement: "tipoDeValla", value: tipoDeVallaFija?.id || "", label: "¿Qué tipo de valla es? *", isError:false, elementType:'radio', errorMessages:['Debe marcar una opción'], options : [], 'disabled':false, isRequired: true, width: '50%',
      },

      tituloTarifaComercial:{
        idelement: "tituloTarifaComercial", title:'Tarifa Comercial', position:"center", elementType:'titulo', showTitleForm: true, name: "tituloTarifaComercial", value: "", isError:false,
      },
      alertaTarifa:{
        idelement: "alertaTarifa", mensaje:'LA TARIFA COMERCIAL NO DEBE SUPERAR EL PROMEDIO DE LA TARIFA COMERCIAL DEBE SER INGRESADA EN QUETZALES (Q) DEBE INCLUIR IVA Y TIMBRE DE PRENSA', elementType:'alerta', showAlertForm: true, name: "alertaTarifa", value: "", isError:false, severity: 'error'
      },
      costoDeValla: {
        idelement: "costoDeValla", value: costo || "", label: `Costo de la valla *`, pattern:"^\\d+(.\\d+)?$", validators: ['required'], errorMessages:['El campo es requerido y solo números o números con decimales'], isError:false, elementType:'texto', name:"costoDeValla", 'disabled': false, width: '50%',
      },
      tituloTipoDeArrendamiento:{
          idelement: "tituloTipoDeArrendamiento", title:'Tipo de Arrendamiento', position:"center", elementType:'titulo', showTitleForm: true, name: "tituloTipoDeArrendamiento", value: "", isError:false,
      },
      alertaArrendamiento:{
        idelement: "alertaArrendamiento", mensaje:'DESCRIBA LAS ESPECIFICACIONES DE CONTRATACIÓN', elementType:'alerta', showAlertForm: true, name: "alertaArrendamiento", value: "", isError:false, severity: 'error'
      },
      descripcionDeEspecificaciones:{
        idelement: "descripcionDeEspecificaciones", value: especDeContratacion || "", label: `Descripción de las especificaciones de contratación`,pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.!#$%&<>~^'=?¿+:;_“”()-*_/@]{4,2000}$", validators: ['required'],
        errorMessages:['El campo es requerido'], isError:false, elementType:'areaTexto','disabled':false, fullWidth: true, name: "descripcionDeEspecificaciones", width: '100%'
      },

      tituloDatosVallaFija:{
          idelement: "tituloDatosVallaFija", title:'Datos de la valla fija', position:"center", elementType:'titulo', showTitleForm: true, name: "tituloDatosVallaFija", value: "", isError:false,
      },
      anchoValla: {
          idelement: "anchoValla", value: anchoValla || "", label: `Ancho (cm) *`, pattern:"^\\d+(.\\d+)?$", validators: ['required'], errorMessages:['El campo es requerido y solo números'], isError:false, elementType:'texto', name:"anchoValla", 'disabled': false, width: '20%',
      },
      altoValla: {
          idelement: "altoValla", value: altoValla || "", label: `Alto (cm) *`, pattern:"^\\d+(.\\d+)?$", validators: ['required'], errorMessages:['El campo es requerido y solo números'], isError:false, elementType:'texto', name:"altoValla", 'disabled': false, width: '20%',
      },
      coordenadasDeUbicacion: {
          idelement: "coordenadasDeUbicacion", value: coordenadas || "", label: `Coordenadas de ubicación *`,
          pattern:"^([-+]?\\d{1,2}[.]\\d+),\\s*([-+]?\\d{1,3}[.]\\d+)?$", validators: ['required'], errorMessages:['El campo es requerido y solo números'], isError:false, elementType:'texto', name:"coordenadasDeUbicacion", 'disabled': false, width: '59%',
      },
      sentidoDeVisualizacion: {
        idelement: "sentidoDeVisualizacion", value: sentidoDeVisualizacion ? {id: sentidoDeVisualizacion?.id, name: sentidoDeVisualizacion?.descripcion} : null, label: "Sentido de visualización *", pattern:"^[1-9][0-9]*$", validators: ['required'],
        errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [], handler: undefined, width: '30%', marginTop: '0'
      },
      imagenDeLaValla:{
        idelement: "imagenDeLaValla", value: imagenDeValla ? imagenDeValla.includes('base64,') ? imagenDeValla : `data:image/jpeg;base64,${imagenDeValla}` : "", label: "Imagen de la valla fija", validators: {required: true, size: "8 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'archivo','disabled':false, name:"imagenDeLaValla", fileWidth: true, src: '', multiple: false, accept:".png, .jpg", showInMovil: true, width: '30%', type: "file"
      },
      ubicacionDeVallaFija:{
        idelement: "ubicacionDeVallaFija", value: descripcionUbicacion|| "", label: `Ubicación de la valla fija`, pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.!#$%&<>~^'=?¿+:;_“”()-*_/@]{4,2000}$", validators: ['required'],
        errorMessages:['El campo es requerido'], isError:false, elementType:'areaTexto','disabled':false, fullWidth: true, name: "ubicacionDeVallaFija", width: '100%'
      },
      acciones: {
          idelement: "acciones", title:'Acciones', position:"center", elementType:'titulo', showTitleForm: true, name: "acciones", value: "", isError:false,
      },
  });

  const guardarDatos = async (dataForm) => {

    setcargandoSolicitud(true);

    const { departamento, municipio, tipoDeValla, costoDeValla, descripcionDeEspecificaciones, anchoValla, altoValla, coordenadasDeUbicacion, sentidoDeVisualizacion, imagenDeLaValla, ubicacionDeVallaFija } = dataForm

    const datosAGuardar = {
        altoValla,
        anchoValla,
        "coordenadas": coordenadasDeUbicacion,
        "costo": costoDeValla,
        "departamento": departamento.id,
        "descripcionUbicacion": ubicacionDeVallaFija,
        "especDeContratacion": descripcionDeEspecificaciones,
        "municipio": municipio.id,
        nitEmpresa: datosDeEmpresa.nit,
        sentidoDeVisualizacion: sentidoDeVisualizacion.id,
        tipoDeValla,
        imagenDeLaValla
    }

    let datosAEnviar = {};
    let response = {};

    if(medioDeComunicacion?.id) {
        datosAGuardar.idMedioDeComunicacion = medioDeComunicacion?.id
        datosAEnviar = { controller: tarifarioDeVallasFijas, action: 'editar', data: datosAGuardar, nombreDelMetodo: "editar/informacionGeneral" };
        response = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));
    } else {
        datosAEnviar = { controller: tarifarioDeVallasFijas, action: 'crear', data: datosAGuardar };
        response = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));
    }
    setcargandoSolicitud(false);

    if(response?.error) return setDatosDeRespuesta({ tipoDeAlerta: 'warning', mensajeDeAlerta: response.error?.message || "REGISTRO NO INGRESADO. INTENTE NUEVAMENTE", mostrarRespuesta: true, });

    if(medioDeComunicacion?.id) return datosEditados(response?.data?.data)

    setDepartamentoYMunicipio({departamento, municipio})
    setRespuestaDeExito(response?.data?.data)
    functions.reiniciarEstadoDelFormulario(camposDelFormulario)
    setMostrarAlertaDeErrorOExito(true);
  }

  const [listadoDeBotones]= useState({
      "guardarDatos":{"label":"Guardar Datos", "icon": <Save />, "callback":guardarDatos,"loading":false,"size":"medium",
              "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
              "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
              isCancel: false,
      },
      "cancelar":{"label":"Cancelar", "icon": <Cancel />,"callback":handleClose,"loading":false,"size":"medium",
              "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
              "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
              isCancel: true,
      },
    });

  const handClose = (_, reason) => {
    if (reason === 'clickaway') {return}
    changeDataResponse('error', '', false)
  };

  const changeDataResponse = (tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta = false) => {
      setDatosDeRespuesta({tipoDeAlerta,mensajeDeAlerta,mostrarRespuesta,})
  };

  const cerrarAlertaDeConfirmacion = () => {
    handleClose(true)
    setMostrarAlertaDeErrorOExito(false);
  }

  const manejadorAccionDelModal = async () => {
    const copiaElementos = Object.assign({}, camposDelFormulario);
    const {departamento, municipio} = departamentoYMunicipio;
    copiaElementos.departamento.value = {id: departamento?.id, name: departamento?.name}
    copiaElementos.municipio.value = {id: municipio?.id, name: municipio?.name}
    copiaElementos.descripcionDeEspecificaciones.value = "";
    copiaElementos.sentidoDeVisualizacion.value = null;
    copiaElementos.ubicacionDeVallaFija.value = "";
    setCamposDelFormulario(copiaElementos);
    setMostrarAlertaDeErrorOExito(false);
  }

  const { tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta} = datosDeRespuesta;

  return (
    <DialogoPantallaCompleta
        openFullScreenDialog={openFullScreenDialog}
        handleClose={handleClose}
        title={title}
        fullscreen={true}
    >
      <Fragment>
          {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
          <AlertaDeRespuesta type={tipoDeAlerta} content={mensajeDeAlerta} open={mostrarRespuesta} handClose={handClose}/>
          <Card>
              <CardContent>
                <Formulario
                  elements={camposDelFormulario}
                  buttonList={listadoDeBotones}
                />
              </CardContent>
          </Card>
          {mostrarAlertaDeErrorOExito && (
                <ModalDeConfirmacion
                    title={`¿Desea agregar otra valla en este municipio?`} message={respuestDeExito || "¡REGISTRADO CORRECTAMENTE!"}
                    open={mostrarAlertaDeErrorOExito} closeModal={cerrarAlertaDeConfirmacion} titleButton={"Sí, agregar"}
                    actionAdd={manejadorAccionDelModal}
                />
          )}
      </Fragment>
    </DialogoPantallaCompleta>
  );
}

export default NuevaVallaFija;